export default [
  {
    meta: {
      is_auth: true,
      is_admin: true,
      title: "État de stock",
      layout: "dashboard",
    },
    path: "/stocks",
    name: "stocks",
    component: () => import("@/layouts/index/StockIndex.vue"),
    children: [
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "État de stock",
          layout: "dashboard",
        },
        path: "index",
        name: "stocks-index",
        component: () => import("@/views/stocks/Listing.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "En rupture de stock",
          layout: "dashboard",
        },
        path: "out/index",
        name: "stocks-out-index",
        component: () => import("@/views/stocks/OutStock.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Transférer la quantité entre les stocks",
          layout: "dashboard",
        },
        path: "transfer/quantity",
        name: "stocks-transfer-quantity",
        component: () => import("@/views/stocks/transferQuantity.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Rajouter une quantité de ce produit en stock",
          layout: "dashboard",
        },
        path: "item/:itemReference/create",
        name: "stocks-create",
        component: () => import("@/views/stocks/Create.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Modifier l'etat de stock",
          layout: "dashboard",
        },
        path: "edit",
        name: "stocks-edit",
        component: () => import("@/views/stocks/Edit.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Supprimer l'etat de stock",
          layout: "dashboard",
        },
        path: ":reference/delete",
        name: "stocks-delete",
        component: () => import("@/views/stocks/Delete.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Statistiques d'inventaire",
          layout: "dashboard",
        },
        path: "statistics/index",
        name: "stocks-statistics-index",
        component: () => import("@/views/stocks/Statistics.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Statistiques d'inventaire",
          layout: "dashboard",
        },
        path: "designations/index",
        name: "stocks-designations-index",
        component: () => import("@/views/stocks/designations/Listing.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Statistiques d'inventaire",
          layout: "dashboard",
        },
        path: "designations/create",
        name: "stocks-designations-create",
        component: () => import("@/views/stocks/designations/Create.vue"),
      },
    ],
  },
];
